// Recovered from the preserved MetaCard production build.
// Behavior is retained; local names and TypeScript types were lost during minification.
import { IconArrowRight } from "../../components/icons.jsx";
import * as React from "react";
import { cardArtUrls } from "./art.jsx";
import * as jsxRuntime from "react/jsx-runtime";
import { IconCards } from "../../components/icons.jsx";
import { preloadCardArt } from "./art.jsx";
import { preloadNextCards } from "./art.jsx";
import { IconPlayerPlay } from "../../components/icons.jsx";
import { IconPlayerPause } from "../../components/icons.jsx";
import { IconX } from "../../components/icons.jsx";
export const H2 = "_overlay_3ndvk_1";
export const L2 = "_scene_3ndvk_2";
export const q2 = "_header_3ndvk_3";
export const G2 = "_title_3ndvk_8";
export const Y2 = "_stage_3ndvk_9";
export const X2 = "_rays_3ndvk_10";
export const Q2 = "_lit_3ndvk_11";
export const Z2 = "_cardTarget_3ndvk_12";
export const V2 = "_card_3ndvk_12";
export const $2 = "_cardReady_3ndvk_15";
export const K2 = "_cardBack_3ndvk_16";
export const J2 = "_cardLoading_3ndvk_19";
export const W2 = "_shine_3ndvk_20";
export const I2 = "_burst_3ndvk_22";
export const F2 = "_details_3ndvk_24";
export const P2 = "_rarity_3ndvk_25";
export const ej = "_footer_3ndvk_29";
export const tj = "_primary_3ndvk_30";
export const aj = "_skip_3ndvk_32";
export const lj = "_note_3ndvk_33";
export const nj = "_total_3ndvk_34";
export const sj = "_grid_3ndvk_35";
export const Pe = {
  overlay: H2,
  scene: L2,
  header: q2,
  title: G2,
  stage: Y2,
  rays: X2,
  lit: Q2,
  cardTarget: Z2,
  card: V2,
  cardReady: $2,
  cardBack: K2,
  cardLoading: J2,
  shine: W2,
  burst: I2,
  details: F2,
  rarity: P2,
  footer: ej,
  primary: tj,
  skip: aj,
  note: lj,
  total: nj,
  grid: sj
};
export const xm = {
  Basic: "#a9c9eb",
  Advanced: "#6ccaff",
  Elite: "#b28bff",
  Majestic: "#ff91bb",
  Absolute: "#ffd47b",
  LIMITED: "#ffb393",
  Mystic: "#dc9cff"
};
export const ij = new Set(["Majestic", "Absolute", "LIMITED", "Mystic"]);
export function RewardThumbnail({
  card: u
}) {
  const [o, m] = React.useState(0),
    r = cardArtUrls(u);
  return r[o] ? jsxRuntime.jsx("img", {
    src: r[o],
    alt: "",
    loading: "lazy",
    decoding: "async",
    onError: () => m(g => g + 1)
  }) : jsxRuntime.jsx(IconCards, {});
}
export function RewardArt({
  card: u,
  onReady: o
}) {
  const [m, r] = React.useState(null);
  return React.useEffect(() => {
    let g = !0;
    return preloadCardArt(u).then(j => {
      g && (r({
        src: j
      }), o());
    }), () => {
      g = !1;
    };
  }, [u, o]), jsxRuntime.jsxs("div", {
    className: `${Pe.card} ${m ? Pe.cardReady : Pe.cardLoading}`,
    children: [m?.src ? jsxRuntime.jsx("img", {
      src: m.src,
      alt: u.name,
      decoding: "async",
      fetchPriority: "high"
    }) : jsxRuntime.jsxs("div", {
      className: Pe.cardBack,
      children: [jsxRuntime.jsx(IconCards, {}), jsxRuntime.jsx("span", {
        children: m ? "META CARD" : "✦"
      })]
    }), jsxRuntime.jsx("i", {
      className: Pe.shine,
      "aria-hidden": "true"
    })]
  });
}
export function OpeningReveal({
  result: u,
  onClose: o
}) {
  const isChest = u.kind === "event-chest";
  const [m, r] = React.useState(0),
    [g, j] = React.useState(!1),
    [B, U] = React.useState(!1),
    [N, y] = React.useState(!1),
    X = React.useRef(null),
    M = React.useRef(() => j(!0)).current,
    R = u.cards,
    H = R[m],
    Y = R.length > 1,
    P = H && ij.has(H.rarity) ? 2200 : 1450,
    W = () => {
      if (m === R.length - 1) {
        Y && !isChest ? y(!0) : o();
        return;
      }
      j(!1), r(ee => ee + 1);
    };
  return React.useEffect(() => {
    const ee = document.activeElement;
    return X.current?.focus(), () => ee?.focus();
  }, []), React.useEffect(() => {
    preloadNextCards(R.slice(m, m + 4));
  }, [R, m]), React.useEffect(() => {
    const ee = () => {
      document.hidden && U(!0);
    };
    return document.addEventListener("visibilitychange", ee), () => document.removeEventListener("visibilitychange", ee);
  }, []), React.useEffect(() => {
    if (!g || B || N || !Y || document.hidden || (isChest && m === R.length - 1)) return;
    const ee = window.setTimeout(() => {
      document.hidden || (m === R.length - 1 ? y(!0) : (j(!1), r(ie => ie + 1)));
    }, P);
    return () => window.clearTimeout(ee);
  }, [g, B, N, Y, m, R.length, P, isChest]), jsxRuntime.jsx("div", {
    className: `${Pe.overlay}${isChest ? " chest-opening-reveal" : ""}`,
    role: "dialog",
    "aria-modal": "true",
    "aria-label": isChest ? "Открытие рундука" : "Открытие карт",
    style: {
      "--reward-color": xm[H?.rarity] || "#c69aff"
    },
    onClick: ee => {
      ee.target === ee.currentTarget && o();
    },
    onKeyDown: ee => {
      if (ee.key === "Escape" && o(), ee.key === "Tab") {
        const ie = Array.from(ee.currentTarget.querySelectorAll("button:not(:disabled)")),
          w = ie[0],
          I = ie[ie.length - 1];
        ee.shiftKey && document.activeElement === w ? (ee.preventDefault(), I?.focus()) : !ee.shiftKey && document.activeElement === I && (ee.preventDefault(), w?.focus());
      }
    },
    children: jsxRuntime.jsxs("section", {
      className: Pe.scene,
      children: [jsxRuntime.jsxs("header", {
        className: Pe.header,
        children: [jsxRuntime.jsx("span", {
          children: isChest ? `НАГРАДА ${m + 1} / ${R.length}` : N ? `ОТКРЫТО ${R.length} КАРТ` : Y ? `КАРТА ${m + 1} / ${R.length}` : "ВАША КАРТА"
        }), jsxRuntime.jsxs("div", {
          children: [Y && !N && jsxRuntime.jsx("button", {
            type: "button",
            "aria-label": B ? "Продолжить автоматически" : "Приостановить показ",
            onClick: () => U(!B),
            children: B ? jsxRuntime.jsx(IconPlayerPlay, {}) : jsxRuntime.jsx(IconPlayerPause, {})
          }), jsxRuntime.jsx("button", {
            className: "mc-icon-button",
            ref: X,
            type: "button",
            "aria-label": "Закрыть открытие",
            onClick: o,
            children: jsxRuntime.jsx(IconX, {})
          })]
        })]
      }), N ? jsxRuntime.jsxs(jsxRuntime.Fragment, {
        children: [jsxRuntime.jsx("h2", {
          className: Pe.title,
          children: "Ваши награды"
        }), jsxRuntime.jsxs("p", {
          className: Pe.total,
          children: ["+", R.reduce((ee, ie) => ee + (ie.compensated ? 0 : ie.points), 0).toLocaleString("ru-RU"), " PTS"]
        }), jsxRuntime.jsx("div", {
          className: Pe.grid,
          children: R.map((ee, ie) => jsxRuntime.jsxs("button", {
            type: "button",
            onClick: () => {
              r(ie), j(!1), U(!0), y(!1);
            },
            style: {
              "--reward-color": xm[ee.rarity] || "#c69aff"
            },
            children: [jsxRuntime.jsx("div", {
              children: jsxRuntime.jsx(RewardThumbnail, {
                card: ee
              })
            }), jsxRuntime.jsx("small", {
              children: ee.rarity
            }), jsxRuntime.jsx("b", {
              children: ee.name
            })]
          }, ie))
        }), u.error && jsxRuntime.jsx("p", {
          className: Pe.note,
          children: u.error
        }), jsxRuntime.jsx("button", {
          type: "button",
          className: Pe.primary,
          onClick: o,
          children: "Готово"
        })]
      }) : jsxRuntime.jsxs(jsxRuntime.Fragment, {
        children: [jsxRuntime.jsx("h2", {
          className: Pe.title,
          children: H.rewardType ? "Награда рундука" : H.compensated ? "Компенсация" : H.isDuplicate ? "Дубликат" : "Новая карта"
        }), jsxRuntime.jsxs("div", {
          className: `${Pe.stage} ${g ? Pe.lit : ""}`,
          onClick: ee => {
            ee.target === ee.currentTarget && o();
          },
          children: [jsxRuntime.jsx("div", {
            className: Pe.rays,
            "aria-hidden": "true"
          }), jsxRuntime.jsx("button", {
            type: "button",
            className: `${Pe.cardTarget}${H.rewardType ? " opening-resource-reward" : ""}`,
            onClick: W,
            disabled: !g,
            "aria-label": isChest ? m === R.length - 1 ? "Завершить открытие" : "Следующая награда" : Y ? "Следующая карта" : "Завершить открытие",
            children: jsxRuntime.jsx(RewardArt, {
              card: H,
              onReady: M
            }, m)
          }), g && jsxRuntime.jsx("div", {
            className: Pe.burst,
            "aria-hidden": "true",
            children: Array.from({
              length: 8
            }, (ee, ie) => jsxRuntime.jsx("i", {
              style: {
                "--angle": `${ie * 45}deg`
              }
            }, ie))
          }, m)]
        }), jsxRuntime.jsxs("div", {
          className: Pe.details,
          children: [jsxRuntime.jsx("span", {
            className: Pe.rarity,
            children: H.rarity
          }), jsxRuntime.jsx("h3", {
            children: H.name
          }), jsxRuntime.jsx("p", {
            children: H.rewardType ? "Зачислено на баланс" : H.universe
          }), jsxRuntime.jsx("strong", {
            children: H.rewardType ? `+${H.amount.toLocaleString("ru-RU")}` : H.compensated ? "Выдана компенсация за повтор LIMITED" : `+${H.points.toLocaleString("ru-RU")} PTS`
          })]
        }, m), u.error && jsxRuntime.jsx("p", {
          className: Pe.note,
          children: u.error
        }), jsxRuntime.jsxs("footer", {
          className: Pe.footer,
          children: [jsxRuntime.jsx("button", {
            type: "button",
            className: Pe.primary,
            onClick: W,
            children: isChest && m === R.length - 1 ? "Готово" : Y ? m === R.length - 1 ? "Все награды" : jsxRuntime.jsxs("span", { className: "mc-inline-icon-label", children: ["Дальше ", jsxRuntime.jsx(IconArrowRight, { "aria-hidden": "true" })] }) : "Забрать карту"
          }), Y && !isChest && jsxRuntime.jsxs("button", {
            type: "button",
            className: Pe.skip,
            onClick: () => y(!0),
            children: ["Показать все ", R.length]
          })]
        })]
      })]
    })
  });
}
